import { render, staticRenderFns } from "./selfOwnedLogisticsList.vue?vue&type=template&id=71e44292"
import script from "./selfOwnedLogisticsList.vue?vue&type=script&lang=js"
export * from "./selfOwnedLogisticsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports